// extracted by mini-css-extract-plugin
export var block = "Loading-module--block--dbd07";
export var container = "Loading-module--container--ccc7f";
export var content = "Loading-module--content--f8beb";
export var logo = "Loading-module--logo--7a885";